/* eslint-disable no-unused-vars */

import { mapActions } from 'vuex';
import loaderMixin from '@/mixins/loader';

const searchMixin = {
  mixins: [
    loaderMixin,
  ],
  methods: {
    ...mapActions('search', ['toggleSearchBar', 'getSearch', 'resetSearchResults']),
    onSearchResults(data) {

    },
    formatQuery(query) {
      return query.trim();
    },
    doSearch(query, options = { reset: true }) {
      if (this.isLoading) return;
      this.loaderAdd(document.body);
      if (options.reset) {
        this.resetSearchResults(query);
      }

      this.getSearch(this.formatQuery(query))
        .then((data) => {
          this.loaderRemove(document.body);
          this.$gtm.trackEvent({
            event: 'Search',
            SearchNumTotalMarketsFound: data.totalMarkets,
          });
          this.onSearchResults(data);

          if (this.$router.currentRoute.query.query !== query) {
            this.$router.push({
              name: 'market-search',
              query: {
                query,
              },
            });
          }
        })
        .catch(() => this.loaderRemove(document.body));
    },
  },
};

export default searchMixin;




// WEBPACK FOOTER //
// ./src/mixins/search.js